import React, { type ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";
import CloseIcon from "@/assets/images/icons2/icon--close.svg";

import { Button2 } from "./Button";

export function CloseButton(props: ComponentProps<typeof Button2>) {
  const { children: _children, className, ...buttonProps } = props;

  return (
    <Button2
      className={cn("tw:size-11 tw:rounded-md", className)}
      size="md"
      variant="blank"
      {...buttonProps}
    >
      <img src={CloseIcon} alt="" />
    </Button2>
  );
}
